/*
 * Break a campaign name onto at most `lines` lines of about `perLine`
 * characters, ellipsising whatever is left over.
 *
 * ECharts 5 does this itself with `axisLabel.overflow: 'break'`, but the
 * bundled type definitions are still the v4 ones and do not admit the option.
 * Rather than cast the whole options object and lose type-checking on the rest
 * of it, the wrap is done here and passed as a plain formatter string.
 */
export const wrapLabel = (name: string, perLine: number, lines = 2) => {
  const words = name.split(' ')
  const rows: string[] = ['']

  words.forEach((word) => {
    const last = rows.length - 1
    const candidate = rows[last] ? `${rows[last]} ${word}` : word

    if (candidate.length <= perLine || !rows[last]) {
      rows[last] = candidate

      return
    }

    rows.push(word)
  })

  if (rows.length <= lines) {
    return rows.join('\n')
  }

  const kept = rows.slice(0, lines)
  // The last line it can show ends in an ellipsis, so a clipped name reads as
  // clipped rather than as a shorter name.
  kept[lines - 1] = `${kept[lines - 1].slice(0, Math.max(0, perLine - 1))}…`

  return kept.join('\n')
}
